import { createReduxModule } from '@skippay/core/utils/reduxUtils';

import { MODULE_NAME } from './constants';
import middleware from './middleware';
import reducer from './slice';

export * from './slice';
export * from './constants';
export * from './selectors';

const createExternalScriptsModule = (config) => {
	return createReduxModule(MODULE_NAME, reducer, null, [middleware(config)]);
};

export default createExternalScriptsModule;
